// extracted by mini-css-extract-plugin
export default {"container":"changeStudentBalance_container__N0KFy","change":"changeStudentBalance_change__MvZNQ"};